import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="form"
export default class extends Controller {
  static targets = ['form'];

  connect() {
  }

  changed({ params: { disableQuerySelector } }) {
    if (disableQuerySelector) {
      const disableElements = document.querySelectorAll(`${disableQuerySelector}`);
      disableElements.forEach(element => {
        element.classList.add('disabled');
      });
    }

    this.formTarget.submit();
  }
}
